var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: { "show-footer": false, "show-title": false },
      on: { cancel: _vm.close },
    },
    [
      _c("div", { staticClass: "limited-modal" }, [
        _c("div", { staticClass: "limited-modal-title" }, [
          _c("span", { staticClass: "material-icons alert-icon" }, [
            _vm._v("warning"),
          ]),
          _vm._v("\n            Hizmetiniz Askıya Alındı\n            "),
          _c(
            "div",
            { staticStyle: { "font-size": "16px", "margin-top": "10px" } },
            [
              _vm._v(
                "\n                Kullanım ve Paket Uyuşmazlığı\n            "
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "limited-modal-description" }, [
          _c("div", { staticClass: "limited-modal-description-text" }, [
            _vm._v(
              "\n                Kullanımınız mevcut paketinizle uyuşmadığı için hesabınız geçici olarak askıya alınmıştır. Kullanıma\n                devam edebilmek için lütfen aşağıdaki güncellemeleri yapınız:\n            "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "limited-modal-description-content" }, [
            _vm.shouldSelectPlan.enabled
              ? _c("div", { staticClass: "information-detail" }, [
                  _c("div", { staticClass: "information-detail-text" }, [
                    _c("b", [_vm._v("Gerekli Eklemeler:")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "information-detail-text-items" },
                      [
                        _vm.shouldSelectPlan.supsisPackage
                          ? _c("div", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.shouldSelectPlan.details.current.users -
                                      _vm.shouldSelectPlan.details.limit
                                        .currentSupsisAgentCount
                                  ) +
                                  "\n                                Temsilci Satın Almalısınız (Mevcut: " +
                                  _vm._s(
                                    _vm.shouldSelectPlan.details.current.users
                                  ) +
                                  "/Limit:\n                                " +
                                  _vm._s(
                                    _vm.shouldSelectPlan.details.limit
                                      .currentSupsisAgentCount
                                  ) +
                                  ")\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.shouldSelectPlan.whatsappQr
                          ? _c("div", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.shouldSelectPlan.details.current
                                      .whatsappQr -
                                      _vm.shouldSelectPlan.details.limit
                                        .currentWhatsappPlanCount
                                  ) +
                                  "\n                                WhatsApp Kanalı Satın Almalısınız (Mevcut:\n                                " +
                                  _vm._s(
                                    _vm.shouldSelectPlan.details.current
                                      .whatsappQr
                                  ) +
                                  "/Limit:\n                                " +
                                  _vm._s(
                                    _vm.shouldSelectPlan.details.limit
                                      .currentWhatsappPlanCount
                                  ) +
                                  ")\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.shouldSelectPlan.whatsappBusiness
                          ? _c("div", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.shouldSelectPlan.details.current
                                      .whatsappBusinessChannels -
                                      _vm.shouldSelectPlan.details.limit
                                        .currentWhatsappBusinessChannelCount
                                  ) +
                                  "\n                                WhatsApp Business Kanalı Satın Almalısınız (Mevcut:\n                                " +
                                  _vm._s(
                                    _vm.shouldSelectPlan.details.current
                                      .whatsappBusinessChannels
                                  ) +
                                  "/Limit:\n                                " +
                                  _vm._s(
                                    _vm.shouldSelectPlan.details.limit
                                      .currentWhatsappBusinessChannelCount
                                  ) +
                                  ")\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.shouldSelectPlan.instagram
                          ? _c("div", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.shouldSelectPlan.details.current
                                      .instagram -
                                      _vm.shouldSelectPlan.details.limit
                                        .instagram
                                  ) +
                                  "\n                                Instagram Kanalı Satın Almalısınız (Mevcut:\n                                " +
                                  _vm._s(
                                    _vm.shouldSelectPlan.details.current
                                      .instagram
                                  ) +
                                  "/Limit:\n                                " +
                                  _vm._s(
                                    _vm.shouldSelectPlan.details.limit.instagram
                                  ) +
                                  ")\n                            "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.shouldSelectPlan.messenger
                          ? _c("div", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.shouldSelectPlan.details.current
                                      .messenger -
                                      _vm.shouldSelectPlan.details.limit
                                        .messenger
                                  ) +
                                  "\n                                Messenger Kanalı Satın Almalısınız (Mevcut:\n                                " +
                                  _vm._s(
                                    _vm.shouldSelectPlan.details.current
                                      .messenger
                                  ) +
                                  "/Limit:\n                                " +
                                  _vm._s(
                                    _vm.shouldSelectPlan.details.limit.messenger
                                  ) +
                                  ")\n                            "
                              ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "limited-modal-footer",
                staticStyle: { "margin-top": "30px" },
              },
              [
                _c(
                  "SupsisButton",
                  {
                    staticStyle: { width: "250px" },
                    attrs: { primary: "" },
                    on: { click: _vm.confirm },
                  },
                  [
                    _vm._v(
                      "\n                        Paketlerim Sayfasına Git\n                    "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-top": "15px",
                      "font-size": "12px",
                      color: "#666",
                    },
                  },
                  [
                    _vm._v(
                      "\n                        Not: Güncellemeleri tamamladıktan sonra hesabınız otomatik olarak yeniden aktif hale\n                        gelecektir.\n                    "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }